module.exports = __webpack_public_path__ + "img/1576312088.81e89354.jpg";